var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGainarrow1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23058 32.0001L0 30.9509L13.7631 14.8096C13.887 14.6652 14.0581 14.5691 14.2462 14.5381C14.4343 14.507 14.6273 14.5432 14.7912 14.6402L27.9876 22.3799L48.5998 0.258301L49.7818 1.35591L28.7324 23.9537C28.6067 24.0883 28.4387 24.1761 28.2561 24.2025C28.0736 24.2289 27.8874 24.1924 27.7285 24.0989L14.5565 16.3753L1.23058 32.0001Z",
    fill: "#14AE26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 5.64944H48.3807V1.61413H44.3328V0H49.1903C49.405 0 49.611 0.085029 49.7628 0.236383C49.9146 0.387736 49.9999 0.593016 49.9999 0.807063V5.64944Z",
    fill: "#14AE26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainarrow1);
export default __webpack_public_path__ + "static/media/gainarrow1.af993c1642157b4b929100899248cde7.svg";
export { ForwardRef as ReactComponent };